// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixedDetails2 {

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  border-radius: 10px;
}

.details-row {
  display: flex;
  align-items: center;

  border: 0.8px solid gray;
  margin-bottom: 5px;
}

.key {
  padding: 10px;
  background-color: #fafafa;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  /* border: 1px solid rgba(128, 128, 128, 0.136); */
  font-weight: bold;
  border-radius: 7px;
}

.image_container {}

.image_inner {
  height: 40px;
  width: 40px;
}

.value_container {
  text-align: left !important;
}

.value {
  justify-content: center;
  font-weight: 600;
  margin-top: 5px !important;
  font-size: 15px;
}

.static_field {
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
}

.parentdiv {
  padding: 8px;
}

.details-card-row {
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  flex-wrap: nowrap;
}



.details-card {
  background: #fafafa;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  padding: 10px 12px 10px 12px;
  /* min-width is now controlled by sidebar state classes below */
  border-left: 4px solid #36c6d3;
  flex: 1 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex ;
  justify-content: space-between
}
/* Sidebar state-based card width */
.sidebar-collapsed .details-card {
  min-width: 180px;
}
.sidebar-expanded .details-card {
  min-width: 230px;
}

.details-card-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.details-card-content {
  margin-left: 0;
  width: 100%;
  text-align: left;
}

@media (max-width: 900px) {
  .details-card-row {
    flex-wrap: wrap;
    gap: 10px;
  }
  .details-card {
    min-width: 140px;
    max-width: 100%;
    flex: 1 1 47%;
    margin-bottom: 10px;
    height: auto;
  }
}

@media (max-width: 600px) {
  .details-card-row {
    flex-direction: column;
    gap: 10px;
  }
  .details-card {
    min-width: 100%;
    max-width: 100%;
    margin-bottom: 10px;
    height: auto;
  }
}

/* Remove old image styles */
.image_container, .image_inner { display: none !important; }

.ant-design-tabs .ant-tabs .ant-tabs-tab {
  /* padding: 0px !important; */
}

.ant-design-tabs .ant-card .ant-card-head {
  min-height: 0px !important;
  padding: 10px 24px !important;
}

.ant-design-tabs .ant-tabs>.ant-tabs-nav .ant-tabs-nav-wrap {
  margin-left: 10px !important;
}

.custom-dropdown .ant-dropdown-menu {
  margin-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;
}

/* .custom_close_icon_my_order {
  color: white;
  background-color: #36c6d3;
  padding: 0px 10px;
  cursor: pointer;
  border-radius: 5px !important;
}

.custom_close_icon_my_order:hover {
  background-color: red;
} */

.handle_submit_action_button {
  background-color: #040724 !important;
  margin-inline-start: 8px !important;
  color: white !important;
  font-size: 14px !important;
  line-height: 1.5714285714285714 !important;
  height: 32px !important;
  padding: 4px 15px !important;
  border-radius: 6px !important;
}

.handle_submit_action_button:hover {
  color: #fff;
  background-color: #080e16 !important;
  box-shadow: 0 2px 0 rgba(0, 137, 228, 0.11) !important;

}

.custom-close-icon {
  color: black !important;
  font-size: 20px !important;
  margin-bottom: 10px;
}

.task_logs_css .ant-table-wrapper .ant-table-thead>tr>th {
  /* border: 1px solid red !important; */
  padding: 2px !important;
  text-align: center !important;
}

.task_logs_css .ant-table-wrapper .ant-table-tbody>tr>td {
  /* border: 1px solid red !important; */
  padding: 2px !important;
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/page-components/OrderDetail/FixedDetails.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kBAAkB;;AAElB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;;;AAIA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,+DAA+D;EAC/D,8BAA8B;EAC9B,SAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd;AACF;AACA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B,iCAAiC,wBAAwB,EAAE;;AAE3D;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,oCAAoC;EACpC,mCAAmC;EACnC,uBAAuB;EACvB,0BAA0B;EAC1B,0CAA0C;EAC1C,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,sDAAsD;;AAExD;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;AAC/B","sourcesContent":[".fixedDetails2 {\n\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n  border-radius: 10px;\n}\n\n.details-row {\n  display: flex;\n  align-items: center;\n\n  border: 0.8px solid gray;\n  margin-bottom: 5px;\n}\n\n.key {\n  padding: 10px;\n  background-color: #fafafa;\n  color: black;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  /* border: 1px solid rgba(128, 128, 128, 0.136); */\n  font-weight: bold;\n  border-radius: 7px;\n}\n\n.image_container {}\n\n.image_inner {\n  height: 40px;\n  width: 40px;\n}\n\n.value_container {\n  text-align: left !important;\n}\n\n.value {\n  justify-content: center;\n  font-weight: 600;\n  margin-top: 5px !important;\n  font-size: 15px;\n}\n\n.static_field {\n  color: rgba(0, 0, 0, 0.8);\n  font-weight: 500;\n}\n\n.parentdiv {\n  padding: 8px;\n}\n\n.details-card-row {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  justify-content: space-between;\n  align-items: stretch;\n  width: 100%;\n  flex-wrap: nowrap;\n}\n\n\n\n.details-card {\n  background: #fafafa;\n  border-radius: 8px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04);\n  padding: 10px 12px 10px 12px;\n  /* min-width is now controlled by sidebar state classes below */\n  border-left: 4px solid #36c6d3;\n  flex: 1 1 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  display: flex ;\n  justify-content: space-between\n}\n/* Sidebar state-based card width */\n.sidebar-collapsed .details-card {\n  min-width: 180px;\n}\n.sidebar-expanded .details-card {\n  min-width: 230px;\n}\n\n.details-card-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 26px;\n  height: 26px;\n  object-fit: contain;\n}\n\n.details-card-content {\n  margin-left: 0;\n  width: 100%;\n  text-align: left;\n}\n\n@media (max-width: 900px) {\n  .details-card-row {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  .details-card {\n    min-width: 140px;\n    max-width: 100%;\n    flex: 1 1 47%;\n    margin-bottom: 10px;\n    height: auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .details-card-row {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .details-card {\n    min-width: 100%;\n    max-width: 100%;\n    margin-bottom: 10px;\n    height: auto;\n  }\n}\n\n/* Remove old image styles */\n.image_container, .image_inner { display: none !important; }\n\n.ant-design-tabs .ant-tabs .ant-tabs-tab {\n  /* padding: 0px !important; */\n}\n\n.ant-design-tabs .ant-card .ant-card-head {\n  min-height: 0px !important;\n  padding: 10px 24px !important;\n}\n\n.ant-design-tabs .ant-tabs>.ant-tabs-nav .ant-tabs-nav-wrap {\n  margin-left: 10px !important;\n}\n\n.custom-dropdown .ant-dropdown-menu {\n  margin-bottom: 20px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* .custom_close_icon_my_order {\n  color: white;\n  background-color: #36c6d3;\n  padding: 0px 10px;\n  cursor: pointer;\n  border-radius: 5px !important;\n}\n\n.custom_close_icon_my_order:hover {\n  background-color: red;\n} */\n\n.handle_submit_action_button {\n  background-color: #040724 !important;\n  margin-inline-start: 8px !important;\n  color: white !important;\n  font-size: 14px !important;\n  line-height: 1.5714285714285714 !important;\n  height: 32px !important;\n  padding: 4px 15px !important;\n  border-radius: 6px !important;\n}\n\n.handle_submit_action_button:hover {\n  color: #fff;\n  background-color: #080e16 !important;\n  box-shadow: 0 2px 0 rgba(0, 137, 228, 0.11) !important;\n\n}\n\n.custom-close-icon {\n  color: black !important;\n  font-size: 20px !important;\n  margin-bottom: 10px;\n}\n\n.task_logs_css .ant-table-wrapper .ant-table-thead>tr>th {\n  /* border: 1px solid red !important; */\n  padding: 2px !important;\n  text-align: center !important;\n}\n\n.task_logs_css .ant-table-wrapper .ant-table-tbody>tr>td {\n  /* border: 1px solid red !important; */\n  padding: 2px !important;\n  text-align: center !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
